import type { WorkflowFormLookupAnswer } from './workflow-form-lookup-contract';

export interface WorkflowReviewHistoryRow {
  decisionRecordId: number;
  stepCode: string;
  occurrenceNumber: number;
  statusCode: string;
  notes: string | null;
  notesLookupAnswer?: WorkflowFormLookupAnswer | null;
  workSummary?: string | null;
  workSummaryLookupAnswer?: WorkflowFormLookupAnswer | null;
}

/** Only server-retained evidence for this stored code can supply a historical label. */
export function reviewHistoryNotes(review: WorkflowReviewHistoryRow): string {
  if (review.notes === null && review.statusCode === 'pending' && reviewHistoryWorkSummary(review) !== null) return '';
  if (review.notes === null) return 'Protected notes';
  const answer = review.notesLookupAnswer;
  return answer?.value === review.notes && typeof answer.label === 'string'
    && answer.label.length > 0 && answer.label.length <= 4000 && answer.label === answer.label.trim()
    ? answer.label : review.notes;
}

/** Submitted work has its own retained evidence; a later review reason is independent. */
export function reviewHistoryWorkSummary(review: WorkflowReviewHistoryRow): string | null {
  const value = review.workSummary;
  if (typeof value !== 'string' || !value.trim() || value.length > 4000) return null;
  const answer = review.workSummaryLookupAnswer;
  return answer?.value === value && typeof answer.label === 'string' && answer.label.length > 0
    && answer.label.length <= 4000 && answer.label === answer.label.trim() ? answer.label : value;
}
